<template>
  <base-section :title="$t('title.corebrands')" :backgroundColor="backgroundColor">
    <template>
      <div class="container">
        <div class="breweries">
          <div class="item" v-for="(brewery, index) in breweries" :key="index" @click="onBrowseClick($t('route.browse'), brewery)">
            <div class="item-padding">
              <img :src="brewery.image" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-section>
</template>

<script>
import Site from '@/api/site'
import BaseSection from '@/components/Section'
export default {
  name: 'Section',
  components: {
    BaseSection
  },
  data () {
    return {
      breweries: [
        {
          title: 'Brewdog',
          image: '/static/brewery/brewery-brewdog.jpg'
        },
        {
          title: 'Heart of Darkness',
          image: '/static/brewery/brewery-heartofdarkness.jpg'
        },
        {
          title: 'Hitachino',
          image: '/static/brewery/brewery-hitachino.jpg'
        },
        {
          title: 'Pasteur Street',
          image: '/static/brewery/brewery-pasteur.jpg'
        }
      ],
      backgroundColor: '#efefef',
      breweryList: []
    }
  },
  mounted () {
    Site.getBrands().then((res) => {
      this.breweryList = res.result
    }).catch((err) => {
      console.log(err.response.data)
    })
  },
  methods: {
    onItemClick (name, param) {
      // this.$router.push({ name, params: { browseId: param } })
      this.$router.push({ path: `/browse/${param}` })
    },
    onBrowseClick (name, obj) {
      let breweryId
      this.breweryList.forEach((item) => {
        if (item.name.toLowerCase() === obj.title.toLowerCase()) {
          breweryId = item.id
        }
      })
      if (breweryId) {
        this.$router.push({ path: `/browse`, query: { id: obj.id, breweryId } })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.breweries {
  width: 100%;
  display: flex;
  align-items: left;
  justify-content: left;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-content: flex-end;

  .item {
    cursor: pointer;
    display: inline-block;
    display: box;
    width: 50%;
    text-align: center;
    @media (min-width: 768px) {
      width: 25%;
    }
    // margin-bottom: 15px;
    // border: 1px solid #ccc;
    .item-padding {
      padding: 5px;
      @media (min-width: 768px) {
        padding: 10px;
      }
    }
    img {
      width: 100%;
      max-width: 100%;
      border: 1px solid #ccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/CoreSection.vue